import dayjs, { Dayjs } from 'dayjs';

// World Cup runs from UTC 2026-06-11T00:00:00Z to UTC 2026-07-21T23:59:59Z.
// Display the calendar boundaries in the user's local timezone.
export const CALENDAR_START_UTC = '2026-06-11T19:00:00Z';
export const CALENDAR_END_UTC = '2026-07-19T23:00:00Z';

export const CALENDAR_START = dayjs.utc(CALENDAR_START_UTC).local().format('YYYY-MM-DD');
export const CALENDAR_END = dayjs.utc(CALENDAR_END_UTC).local().format('YYYY-MM-DD');

export function toDayKey(value?: string | Dayjs | null): string {
  if (!value) return '';
  const parsed = typeof value === 'string' ? dayjs(value) : value;
  if (!parsed.isValid()) return '';
  return parsed.format('YYYY-MM-DD');
}

export function formatDayLabel(day: string): string {
  const parsed = dayjs(day);
  if (!parsed.isValid()) return day;
  return parsed.format('ddd, MMM D');
}

export function getCalendarDays(
  start: string = CALENDAR_START,
  end: string = CALENDAR_END
): string[] {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  if (!startDate.isValid() || !endDate.isValid()) return [];

  const days: string[] = [];
  let cursor = startDate;
  while (cursor.isBefore(endDate) || cursor.isSame(endDate, 'day')) {
    days.push(cursor.format('YYYY-MM-DD'));
    cursor = cursor.add(1, 'day');
  }
  return days;
}
